<div class="container d-flex flex-column">
    <h2 class="title-center my-2">Field Paths</h2>
    <div class="content">
      @if(gridSettingsReady) {
        <app-lt-png-table #fieldPathGrid [gridSettingsInput]="fieldPathGridSettings()" (selectionChange)="handleSelectedRow($event)" (addClicked)="setAdding()" (editClicked)="setUpdating($event)" (deleteClicked)="deleteFieldPath($event)" />
      }
    </div>
</div>

<ng-template #addUpdateFieldForm>
  <h2 matDialogTitle>{{ isNew ? "Add New Encompass API Field Path" : "Edit Encompass Field Path" }}</h2>
  <mat-dialog-content>
    <div class="field-path-form-content">
      <ng-container>
        <mat-form-field appearance="fill" class="field-path-form-field">
          <mat-label>Field ID</mat-label>
          <input matInput [formControl]="fieldIdFormControl" placeholder="Ex. 364">
            <mat-error *ngIf="fieldIdFormControl.hasError('checkNotInList')">
              FieldId must not already exist.
            </mat-error>
            <mat-error *ngIf="fieldIdFormControl.hasError('required')">
              FieldId is required.
            </mat-error>
            <mat-error *ngIf="fieldIdFormControl.hasError('maxLength')">
              FieldId must be 100 characters or less.
            </mat-error>
        </mat-form-field>
      </ng-container>

      <ng-container>
        <mat-form-field appearance="fill" class="field-path-form-field">
          <mat-label>API Field Path</mat-label>
          <input matInput [formControl]="apiFieldPathFormControl" placeholder="Ex. $.loanNumber" >
            <mat-hint *ngIf="!isNew">Original Value: {{selectedItem?.apiFieldPath}}</mat-hint>
            <mat-error *ngIf="apiFieldPathFormControl.hasError('required')">
              API Field Path is required.
            </mat-error>
            <mat-error *ngIf="apiFieldPathFormControl.hasError('maxLength')">
              API Field Path must 500 characters or less.
            </mat-error>
        </mat-form-field>
      </ng-container>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matButton [disabled]="savingFieldPath" (click)="onCancel()">Close</button>
    <button matButton [disabled]="savingFieldPath" (click)="onSave()">Save</button>
  </mat-dialog-actions>
</ng-template>
